import { render } from "./SyncTogglePanel.vue?vue&type=template&id=1550a444&scoped=true"
import script from "./SyncTogglePanel.vue?vue&type=script&lang=js"
export * from "./SyncTogglePanel.vue?vue&type=script&lang=js"

import "./SyncTogglePanel.vue?vue&type=style&index=0&id=1550a444&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1550a444"]])

export default __exports__